module.exports = "/fonts/fa-regular-400.eot?0f9d1f74777600d15191f64c71380ffb";